module.exports = __webpack_public_path__ + "static/media/soeren.ebd5129d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/soeren.jpg
// module id = 617
// module chunks = 0